import React, { useState, useCallback, useMemo, ComponentType } from 'react';
import { i18n } from '@factorin/container.macro';

import { Text, Button, TransitionComponent, animation, cn } from 'Modules/ui';

import styles from './index.module.scss';
import { LanguageSelectorProps } from './types';


const languages = [
    {
        name: 'RU',
        key: 'ru',
    },
    {
        name: 'EN',
        key: 'en',
    },
];

export const LanguageSelector: ComponentType<LanguageSelectorProps> = React.memo(({
    classNames = {},
    languageChanged,
}) => {
    const [language, setLanguage] = useState(() => i18n.language);
    const changeLanguage = useCallback(
        language => {
            i18n.changeLanguage(language);
            if (languageChanged)
                languageChanged(language);
            setLanguage(language);
        },
        [languageChanged],
    );

    const value = useMemo(
        () => languages.find(({ key }) => key === language),
        [language],
    );

    const [visible, setVisible] = useState(false);
    const showPopup = useCallback(() => setVisible(true), []);
    const hidePopup = useCallback(() => setVisible(false), []);

    return (
        <div className={cn(
            styles.selector,
            classNames.languageSelector,
        )}
        >
            <Text
                component={Button}
                variant='auxiliary'
                className={styles.value}
                onClick={!visible ? showPopup : hidePopup}
            >
                {value.name}
            </Text>
            <TransitionComponent in={visible} timeout={animation}>
                <div className={styles.options}>
                    {languages.map(({ key, name }, index) => (
                        <Text
                            key={index}
                            component={Button}
                            variant='auxiliary'
                            onClick={() => {
                                hidePopup();
                                changeLanguage(key);
                            }}
                        >
                            {name}
                        </Text>
                    ))}
                </div>
            </TransitionComponent>
        </div>
    );
});
